import { removeTime } from '@/utils/date'
import { addDays } from 'date-fns'

export const acctNoRangeFrom = {
  getMessage: (field, args) => {
    return field + ' must less than or equal To Account No.'
  },
  validate: (value, args) => {
    return !(value > args)
  }
}

export const acctNoRangeTo = {
  getMessage: (field, args) => {
    return field + ' must greater than or equal From Account No.'
  },
  validate: (value, args) => {
    return !(value < args)
  }
}

export const checkDateRangeTo = {
  getMessage: (field, args) => {
    if (args.length > 0) {
      return 'Must be a later From Date'
    }
  },
  validate: (value, args) => {
    if (value) {
      if (args.length > 0) {
        return removeTime(value) >= removeTime(args)
      } else {
        return true
      }
    } else {
      return true
    }
  }
}

export const checkDateRangeFrom = {
  getMessage: (field, args) => {
    if (args.length > 0) {
      return 'From Date cannot be later than To Date'
    }
  },
  validate: (value, args) => {
    if (value) {
      if (args.length > 0) {
        return removeTime(value) <= removeTime(args)
      } else {
        return true
      }
    } else {
      return true
    }
  }
}

export const checkAgeing = {
  getMessage: (field, args) => {
    var agePer = field[field.length - 1]
    var agePerInt = parseInt(agePer)
    if (agePerInt === 1) {
      return field + ' must be earlier than Current Month'
    } else {
      return field + ' must be earlier than Ageing Period ' + (agePerInt - 1)
    }
  },
  validate: (value, args) => {
    var pValue = addDays(value, 1)
    if (pValue) {
      return removeTime(pValue) <= removeTime(args)
    } else {
      return true
    }
  }
}

export const checkCurrMth = {
  getMessage: (field, args) => {
    return field + ' cannot be a future date'
  },
  validate: (value, args) => {
    if (value) {
      return removeTime(value) <= removeTime(new Date())
    } else {
      return true
    }
  }
}

export const labels = {
  // Ageing
  rptType: 'Type of Report',
  ageBy: 'Age by',
  currMth: 'Current Month',
  agePer1: 'Ageing Period 1',
  agePer2: 'Ageing Period 2',
  agePer3: 'Ageing Period 3',
  agePer4: 'Ageing Period 4',
  agePer5: 'Ageing Period 5',
  agePer6: 'Ageing Period 6',
  agePer7: 'Ageing Period 7',
  agePer8: 'Ageing Period 8',
  agePer9: 'Ageing Period 9',
  colHeadCurrMth: 'Column Heading Current Month',
  colHeadAgePer1: 'Column Heading Ageing Period 1',
  colHeadAgePer2: 'Column Heading Ageing Period 2',
  colHeadAgePer3: 'Column Heading Ageing Period 3',
  colHeadAgePer4: 'Column Heading Ageing Period 4',
  colHeadAgePer5: 'Column Heading Ageing Period 5',
  colHeadAgePer6: 'Column Heading Ageing Period 6',
  colHeadAgePer7: 'Column Heading Ageing Period 7',
  colHeadAgePer8: 'Column Heading Ageing Period 8',
  colHeadAgePer9: 'Column Heading Ageing Period 9',
  // Report Options
  acctNoFrom: 'From Account No.',
  acctNoTo: 'To Account No.',
  dateRangeBy: 'Date Range By',
  tranDateFrom: 'From',
  tranDateTo: 'To',
  branch: 'Branch',
  homeBrn: 'Home Branch',
  interType: 'Intermediary Type',
  interGrp: 'Intermediary Group',
  incZeroBalTran: 'Include 0.00 balance transactions',
  sepFigCrDr: 'Separate figures for Debit and Credit',
  aplCrTermsToAgeing: 'Apply Credit Terms to Ageing',
  prtRptRunTime: 'Print Run-time Parameters',
  unDueTranCommDate: 'Undue by Transaction / Commencement Date',
  export: 'Export to'
}

export const rptTypeList = [
  // { label: 'By Intermediary Type Detail', value: 1 },
  // { label: 'By Intermediary Type. Detail and Summary', value: 2 },
  // { label: 'By Intermediary Type Summary', value: 3 },
  // { label: 'By Intermediary Group Detail', value: 1 },
  // { label: 'By Intermediary Group. Detail and  Summary', value: 2 },
  // { label: 'By Intermediary Group Summary', value: 3 },
  { label: 'By Account Group Detail', value: 4 },
  { label: 'By Account Group Detail and Summary', value: 5 },
  { label: 'By Account Group Summary', value: 6 }
]

export const ageByList = [
  { label: 'Transaction Date', value: 'T' },
  { label: 'Commencement Date', value: 'C' },
  { label: 'Accounting Period', value: 'A' }
]

export const sortingList = [
  { label: 'Print by Account No, Fund, Suffix', value: 1 },
  { label: 'Print by Fund, Suffix, Account No', value: 2 }
]

export const interGrpList = [
  { label: '10 - Agent', value: '10' },
  { label: '11 - Broker', value: '11' },
  { label: '12 - Financial Institution', value: '12' },
  { label: '20 - Cedant/Reinsurer', value: '20' },
  { label: '25 - Direct Client', value: '25' },
  { label: '30 - Loss Adjuster', value: '30' },
  { label: '31 - Repairer', value: '31' },
  { label: '32 - Solicitor', value: '32' },
  { label: '33 - Forensic', value: '33' },
  { label: '34 - Survey Agent', value: '34' },
  { label: '35 - Settling Agent', value: '35' },
  { label: '40 - Contractor', value: '40' },
  { label: '41 - Guarantor', value: '41' },
  { label: '50 - Third Party', value: '50' },
  { label: '60 - Supplier', value: '60' },
  { label: '70 - Other', value: '70' }
]
